let BrowserInfo = {
    isAndroid: Boolean(navigator.userAgent.match(/android/i)),
    isIphone: Boolean(navigator.userAgent.match(/iphone|ipod/ig)),
    isIpad: Boolean(navigator.userAgent.match(/ipad/i)),
    isWeChat: Boolean(navigator.userAgent.match(/MicroMessenger/ig)),
    isAlipay: Boolean(navigator.userAgent.match(/AlipayClient/ig)),
    isMiniProgram: Boolean(navigator.userAgent.match(/miniProgram/i)),
    isPhone: Boolean(/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent))
        || Boolean(navigator.userAgent.match(/miniProgram/i))
        || (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram')
        || Boolean(localStorage.getItem && localStorage.getItem('wx_token'))
}
export default  BrowserInfo